import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import device from './moudles/device';
import upRecord from './moudles/upRecord';
import callRecord from './moudles/callRecord';
import tibiot from './moudles/tibiot';
import shingsouIot from './moudles/shingsouIot';
import projectList from './moudles/projectList';
import iotReplaceRecord from './moudles/iotReplaceRecord';
import projectGroup from './moudles/projectGroup';
import messageLog from './moudles/messageLog';
import deviceRechargeInfo from './moudles/deviceRechargeInfo';
import deviceSaleRecord from './moudles/deviceSaleRecord';
import {commonConstant} from '@/utils/Constants';
import {logoutSystem} from '@/api/public';
import commonUtil from '@/utils/commonUtil';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loading:true,
    btnPermission:{ // 按钮权限
      /*edit:false,
      add:true*/
    },
    // 大屏显示数据
    bigScreenData:{},
  },
  mutations: {
    logout(state,doNotJump){
      if(!doNotJump){
        let token = commonUtil.getLoginToken();
        logoutSystem(token);
        router.push('/');
      }
      // 清空本地数据
      sessionStorage.clear();
      /* localStorage.removeItem(commonConstant.USER_ACCOUNT_KEY);
      localStorage.removeItem(commonConstant.PASSWORD_KEY);
      localStorage.removeItem(commonConstant.REMENBER_ME_KEY); */
      localStorage.removeItem(commonConstant.TOKEN_NAME);
      // 清空加载
      state.loading = false;
      // 清空按钮权限
      state.btnPermission={};
      state.bigScreenData={};
    },
    setBtnPermission(state,btnPermission){
      state.btnPermission = btnPermission;
    }
  },
  modules:{
    device,
    upRecord,
    callRecord,
    shingsouIot,
    tibiot,
    projectList,
    iotReplaceRecord,
    projectGroup,
    messageLog,
    deviceRechargeInfo,
    deviceSaleRecord,
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js